// 'use client'

import Image from 'next/image'
import { useCallback } from 'react'

import { AuthService } from '@/services'
import { dialog } from '@/utils/addon'

import { Link } from '../link'

export function NavbarComponent() {
  // __FUNCTION's
  const handleLogout = useCallback(async () => {
    const { isConfirmed } = await dialog.confirm('Confirm to Signout?')
    if (isConfirmed) {
      AuthService.signOut(() => {
        location.href = '/'
      })
    }
  }, [])

  // __RENDER
  return (
    <nav className='ui--navbar sticky top-0'>
      <div className='ui--navbar-container grid h-full gap-6'>
        <div className='ui--navbar-rows rounded-b-lg pt-8'>
          <Image
            className='logo mx-auto object-contain object-center invert'
            src='/static/images/lamptitude.png'
            alt='Lamptitude Logo'
            width={160}
            height={36}
            quality={100}
            priority
          />
        </div>

        <div className='ui--navbar-rows pt-2'>
          <ul className='ul mirror use-ring'>
            <li className='li'>
              <Link className='btn' to='/lobby' key='.lobby'>
                <span className='icon bi bi-window-desktop'></span>
                <span className='text capitalize'>index</span>
              </Link>
            </li>

            <li className='li'>
              <Link className='btn' to='/banners' key='.banner'>
                <span className='icon bi bi-image'></span>
                <span className='text capitalize'>banner's</span>
              </Link>
            </li>

            <li className='li'>
              <Link className='btn' to='/canopies' key='.canopy'>
                <span className='icon bi bi-layers-half'></span>
                <span className='text capitalize'>canopies</span>
              </Link>
            </li>

            <li className='li'>
              <Link className='btn' to='/products' key='.product'>
                <span className='icon bi bi-lamp'></span>
                <span className='text capitalize'>product's</span>
              </Link>
            </li>

            <li className='li'>
              <Link className='btn' to='/docs' key='.docs'>
                <span className='icon bi bi-journal-text'></span>
                <span className='text capitalize'>document's</span>
              </Link>
            </li>

            <li className='li'>
              <Link className='btn' to='/users' key='.user'>
                <span className='icon bi bi-people'></span>
                <span className='text capitalize'>user's</span>
              </Link>
            </li>
          </ul>

          <ul className='ul mirror use-ring mt-7'>
            <li className='li'>
              <a className='btn router-link' key='.menu-1'>
                <span className='icon bi bi-hash'></span>
                <span className='text capitalize'>menu 1</span>
              </a>
            </li>

            <li className='li'>
              <a className='btn router-link' key='.menu-2'>
                <span className='icon bi bi-hash'></span>
                <span className='text capitalize'>menu 2</span>
              </a>
            </li>

            <li className='li'>
              <a className='btn router-link' key='.menu-3'>
                <span className='icon bi bi-hash'></span>
                <span className='text capitalize'>menu 3</span>
              </a>
            </li>

            <li className='li'>
              <a className='btn router-link' key='.menu-4'>
                <span className='icon bi bi-hash'></span>
                <span className='text capitalize'>menu 4</span>
              </a>
            </li>
          </ul>
        </div>

        <div className='ui--navbar-rows flex items-center justify-end gap-2'>
          <button className='btn size-12 rounded-lg bg-gray-400/5 opacity-50 backdrop-blur' type='button'>
            <span className='icon bi bi-gear text-xl'></span>
          </button>

          <button
            className='btn size-12 rounded-lg bg-gray-400/5 backdrop-blur-sm'
            type='button'
            onClick={handleLogout}
          >
            <span className='icon bi bi-power text-2xl text-red-600'></span>
          </button>
        </div>
      </div>
    </nav>
  )
}
